///<reference types='./dev.glob.d.ts' />

const DEBUG_MODE_STORAGE_KEY: 'DEBUG_MODE' = 'DEBUG_MODE' as const;
globalThis.isDebugMode = function isDebugMode(): boolean {
	return localStorage.getItem(DEBUG_MODE_STORAGE_KEY) === 'true';
};
